// Local development and the dev deployment, as opposed to production.
export const isTestEnvironment = () =>
  window.location.host.includes('localhost') ||
  window.location.host.includes('microniq.geshdo.dev');
